import React, { PropTypes, Component } from 'react'
import styled from 'styled-components'

const LyricWrapper = styled.div`
  width: ${props => props.loaded ? `${props.width}px` : 'auto'};
  height: ${props => props.loaded ? `${props.height}px` : 'auto'};
  &:before {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }
  > img {
    opacity: ${props => props.loaded ? 1 : 0};
    transition: ${props => props.loaded ? 'opacity 0.5s 1s' : 'none'};
  }
`

class Lyric extends Component {
  render () {
    let {loaded, src, width, height} = this.props
    return (
      <LyricWrapper loaded={loaded} width={width} height={height}>
        <img src={loaded ? src : 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'} width={width} height={height} role='presentation' />
      </LyricWrapper>
    )
  }
}

Lyric.propTypes = {
  loaded: PropTypes.bool,
  src: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number
}

export default Lyric



/** WEBPACK FOOTER **
 ** ./src/components/Lyric.js
 **/